import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import { FormHelperText } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import axios from 'axios';
import LoadingButton from '../../LoadingButton';
import SelectField from '../../SelectField';
import { updateAccount, reset } from '../services/authSlice';

const apiUrl = `${process.env.REACT_APP_API_URL}/api`;

function StreetSelectionForm() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [streetOptions, setStreetOptions] = useState([]);
  const { loading, message, account } = useSelector((state) => state.auth);

  const initialValues = {
    street: '',
  };

  const validationSchema = yup.object({
    street: yup
      .string()
      .required(t('error.requiredField')),
  });

  useEffect(() => {
    axios.get(`${apiUrl}/street/list`).then((response) => {
      const options = response.data.map((s) => ({
        value: s.name,
        label: s.name,
      }));
      setStreetOptions(options);
    });
  }, []);

  useEffect(() => {
    if (account?.contactDetail?.streetId) {
      navigate('/');
    }
  }, []);

  useEffect(() => {
    if (!isSaving) {
      return;
    }
    switch (loading) {
      case 'failed':
        setErrorMessage(message);
        setIsLoading(false);
        break;
      case 'pending':
        setIsLoading(true);
        break;
      case 'succeeded':
        setErrorMessage(null);
        setIsSaving(false);
        setIsLoading(false);
        navigate('/');
        break;
      default:
    }
    dispatch(reset());
  }, [loading, message]);

  return (
    <div>
      <h5 className="text-center mb-4">{t('alert.streetIsRequired')}</h5>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          setIsSaving(true);
          dispatch(updateAccount(values));
        }}
      >
        <div className="col">
          <Form noValidate>
            <div className="row">
              <div className="col-12 mb-4">
                <SelectField
                  name="street"
                  label={t('user.street')}
                  options={streetOptions}
                  required
                />
              </div>
            </div>
            {errorMessage && (
              <div className="d-flex justify-content-center row">
                <div className="col-12 col-sm-auto col-md-auto mt-2">
                  <FormHelperText error>
                    {errorMessage}
                  </FormHelperText>
                </div>
              </div>
            )}
            <div className="d-flex justify-content-center row">
              <div className="col-12 col-sm-6 col-md-4 mt-4 mb-4">
                <LoadingButton
                  fullWidth
                  variant="contained"
                  title={t('common.button.save')}
                  type="submit"
                  loading={isLoading}
                />
              </div>
            </div>
          </Form>
        </div>
      </Formik>
    </div>
  );
}

export default StreetSelectionForm;
